







































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Option} from '@/models';

import CrudOptionEdit from '@/components/Crud/Option/Edit.vue';

@Component({
	components: {
		CrudOptionEdit,
	}
})
export default class CrudOptionEditDialog extends Vue {
	@InOut({ type: Option  , isVModel: true }) private value!: Option;

	@Emit()
	private onSubmit(option: Option) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
